import React, { Component } from "react";
import { connect } from "react-redux";
import { pathToJS, firebaseConnect } from "react-redux-firebase";
import { Redirect } from "react-router-dom";

import "./style.scss";

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.match.params.email,
      canChangeEmail: !props.match.params.email,

      password: "",
      password_conf: ""
    };
  }

  submit() {
    this.props.firebase.createUser(
      { email: this.state.email.toLowerCase(), password: this.state.password },
      { role: "student", email: this.state.email.toLowerCase() }
    );
  }

  componentWillMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className="LoginPage">
        {this.props.auth &&
          <Redirect
            to={{
              pathname: "/group/0"
            }}
          />}
        <div className="content">
          <h1>Welcome to SIMI</h1>
          <h2>Create your account</h2>
          <div className="LoginForm">

            <input
              type="email"
              placeholder="Email"
              disabled={!this.state.canChangeEmail}
              value={this.state.email}
              onChange={(e => {
                this.setState({ email: e.target.value });
              }).bind(this)}
            />

            <input
              type="password"
              value={this.state.password}
              placeholder="Password"
              onChange={(e => {
                this.setState({ password: e.target.value });
              }).bind(this)}
            />
            <input
              type="password"
              value={this.state.password_conf}
              placeholder="Confirm Password"
              onChange={(e => {
                this.setState({ password_conf: e.target.value });
              }).bind(this)}
            />
            <input
              type="submit"
              value="Create Account"
              disabled={
                this.state.password.length < 6 ||
                  this.state.password !== this.state.password_conf
              }
              onClick={this.submit.bind(this)}
            />
          </div>

        </div>
      </div>
    );
  }
}

export default connect(
  // Map state to props
  ({ firebase }) => ({
    authError: pathToJS(firebase, "authError"),
    auth: pathToJS(firebase, "auth")
  })
)(firebaseConnect()(Login));



// WEBPACK FOOTER //
// ./src/routes/create-account/index.js